import Helper from "@/helpers/helpers.js"
import Vue from 'vue';
export const Counter = {
	namespaced : true,
	state :{	
		conte : 0,
		list : [],
	},
	getters:{
		getList : (state)=> {
	        return state.list;
	    },
	    getCounterById:(state)=>(id)=>{
	    	return state.list.find(x=> x.layout_id==id) || { devices :{},  counts : 0 }
	    },
	    getSmartByRuleId:(state)=>(ruleId)=>{
	    	return state.list.find(x=> x.ruleId==ruleId);
	    },
	    conte:(state)=>{
	    	return state.conte 
	    },
	},
	actions:{
		
	},
	mutations:{
		setList(state, list) {
      		state.list = list;
	    },
	    setCount(state, val){	    	
	    	const idx=state.list.findIndex(x=> x.layout_id == val.layout_id);
	    	if (idx>=0) {
	    		state.list.splice(idx,1,val);
	    	}else{
	    		state.list.push(val);
	    	}
	    	// state[val.layout_id]=0;
	    },
	    
	    addCount(state,val){
	    	const idx=state.list.findIndex(x=> x.layout_id == val.layout_id);
	    	if (idx>=0) {
	    		state.list[idx].counts += val.count
	    	}
	    	state.conte++;
	    	// state[val.layout_id]+=val.count;
	    },	    
	    clearCount(state, val){
	    	const idx = state.list.findIndex( x=> x.layout_id==val);	    	
			console.log("clearCount ", val, idx)
			if (idx>=0) {				
				state.list.splice(idx,1);
			}
	    },
	    addCountDevice(state, val){
	    	const idx=state.list.findIndex( x=> x.layout_id==val.layout_id);
	    	if (idx>=0) {	    		
		    	if (state.list[idx].devices && !state.list[idx].devices[val.deviceId]) {
		    		state.list[idx].devices[val.deviceId] = {subtotal : 0, date : ""}
		    	}	    	
		    	state.list[idx].devices[val.deviceId].subtotal += val.subtotal;		    	
		    	state.list[idx].counts += val.subtotal;
		    	state.conte++; 	
	    	}
	    },
	    addCountData(state,val){
	    	const idx=state.list.findIndex( x=> x.layout_id==val.layout_id);
	    	if (idx>=0) {	    		
	    		if (val.count1) {
	    			// state.list[idx].tag1.counts+=val.count1;
	    			state.list[idx].devices["tag1"].subtotal+=val.count1;
	    		}
		    	if (val.count2) {
	    			// state.list[idx].tag2.counts+=val.count2;
	    			state.list[idx].devices["tag2"].subtotal+=val.count2;

	    		}
		    	if (val.operator) {
		    		state.list[idx].counts = Helper.renderOperation(val.operator, state.list[idx].devices["tag1"].subtotal ,state.list[idx].devices["tag2"].subtotal); // .devices.counts / .tag2.counts
		    		
		    	}
	    	}
	    },

	    renderTime(state, val){	    	
	    	if (state && state.list.length && val) {    		
		    	state.list.forEach((it,idx)=>{		    		
		    		const hour =  it.start || "00:00"; 	    			
		    		if (hour == Helper.getDateFormat(val, "HH:mm")) {
		    			state.list[idx].time=val;		    		
		    			state.list[idx].actionDate(state.list[idx]);
		    		}		    		
		    	})
		    }
	    },
	    renderHistoryCount(state,val){    			
    		if (state && state.list.length && val ) {
    			// console.log("CHECK LIST " )
	    		state.list.forEach((item,idx)=>{	    			
	    			if (item.analytic=='smart_event' && !item.isHistory) {
						if (item.ruleId && val.ruleId == item.ruleId) { 
							if (val.devices && val.devices.length) {
								val.devices.forEach((it)=>{
									if (state.list[idx].devices && !state.list[idx].devices[it.deviceId]) {
		    							state.list[idx].devices[it.deviceId]={subtotal: 0, date: new Date(), name : it?.hostname};
		    						}
		    						state.list[idx].devices[it.deviceId].date = Helper.formatDate(it.timestamp || it.unix_itme_stamp);
									state.list[idx].devices[it.deviceId].subtotal = it.total;  
								})
							}
							state.conte++;
							state.list[idx].counts=val.total;
						}
					}
	    		})
	    	}
	    },
	    // pendint test with smart event and data
	    renderCount(state, val){
	    	// console.log("SATETE COUNT ", val)
	    	if (state && state.list.length && val ) {
		    	state.list.forEach((it,idx)=>{
		    		
		    		// if (it!="conte") {		    			
			    		const item=it;
		    			if (val.typeCount=='motion' && item.analytic=='motion') {
		    				if (item.deviceId.includes(val.deviceId)) {
		    					state.list[idx].devices[val.deviceId].subtotal += 1;
		    					state.list[idx].devices[val.deviceId].date = new Date();
		    					state.list[idx].counts += 1;
		    					state.conte++;
		    				}
		    			}else if (val.typeCount=='lpr' && item.analytic=='lpr') {
		    				if (item.deviceId.includes(val.deviceId)) {
		    					state.list[idx].devices[val.deviceId].subtotal += 1;
		    					state.list[idx].devices[val.deviceId].date = new Date();
		    					state.list[idx].counts += 1;
		    					state.conte++;
		    				}
		    			}else if (val.typeCount=='action' && item.analytic=='actions') {
		    				if (item.deviceId.includes(val.deviceId)) {
		    					state.list[idx].devices[val.deviceId].subtotal += 1;
		    					state.list[idx].devices[val.deviceId].date = new Date();
		    					state.list[idx].counts += 1;
		    					state.conte++;
		    				}
		    			}else if (val.typeCount=='avc' && item.analytic=='avc') {
		    				if (item.deviceId.includes(val.deviceId)) {
		    					state.list[idx].devices[val.deviceId].subtotal += 1;
		    					state.list[idx].devices[val.deviceId].date = new Date();
		    					state.list[idx].counts += 1;
		    					state.conte++;
		    				}
		    			}else if (val.typeCount=='object') {
		    				if (item.deviceId.includes(val.deviceId)) {
		    					let tempCount=val.analytics_results && val.analytics_results.length?val.analytics_results.filter(x => (x && (x.tag == item.tag || x.action == item.tag))) : [];
		    					if (tempCount && tempCount.length) {	    						
			    					state.list[idx].devices[val.deviceId].subtotal = tempCount.length;
			    					state.list[idx].devices[val.deviceId].date = new Date();
				    				let countTemp = 0
				    				for (let dev in state.list[idx].devices){
										countTemp += state.list[idx].devices[dev].subtotal;
									}
			    					state.list[idx].counts = countTemp;
		    						state.conte++;
		    					}
		    				}
		    			}
		    			else if ((val.typeCount=='smart_event' || val.typeCount=='alerts') && ['smart_event', 'data'].includes(item.analytic)) {
		    				if (item.analytic=='smart_event') {
		    					if (item.ruleId && val.ruleId == item.ruleId) { // item.Tag && ( / = item.Tag.id || val.ruleId =
		    						let countTemp = val.analytics_results.length || 1; 
		    						if (state.list[idx].devices && !state.list[idx].devices[val.deviceId]) {
		    							state.list[idx].devices[val.deviceId]={subtotal: 0, date: new Date(), name : val?.hostname};
		    						}
		    						// item.counts+=countTemp;
		    						state.conte+=countTemp;
		    						// console.log("val.deviceId ", val.deviceId, item)
		    						item.devices[val.deviceId].date = Helper.formatDate(val.timestamp || val.unix_itme_stamp);
		    						// console.log("smart_event ", val.ruleId, item.Tag.id ,countTemp,  state.list[idx].counts)
		    						if (item.isHistory) {		    							
			    						item.devices[val.deviceId].subtotal += countTemp;  
			    						state.list[idx].counts+=countTemp;
		    						}
		    						// else{
		    						// 	item.devices[val.deviceId].subtotal = countTemp;
		    						// 	let countDevices=0;  
		    						// 	for(const it in item.devices){
		    						// 		countDevices+=item.devices[it].subtotal;
		    						// 	}
			    					// 	state.list[idx].counts=countDevices;
		    						// }
		    					}

		    				}
		    				// ------------------------------------ DATA ------------------------------
		    				if (item.analytic=='data' && item.tag1 && item.tag2) {
		    					// console.log("CHECK RESULT ",  item.tag, item.tag1, item.tag1.counts, item.operator ,item.tag2, item.tag2.counts, " = " , Helper.renderOperation(item.operator, { t1 :item.tag1.counts , t2: item.tag2.counts}), " | ", item.tag1.counts -  item.tag2.counts)
		    					if (val.ruleId == item.tag1.ruleId) {
		    						if (state.list[idx].devices && !state.list[idx].devices["tag1"]) {
		    							state.list[idx].devices["tag1"]={subtotal: 0, date: new Date(), name : item.tag1?.name};
		    						}
		    						// item.tag1.counts += countTemp;
		    						// item.counts+=countTemp
		    						// state.list[idx]+=countTemp
		    						item.devices["tag1"].date = Helper.formatDate(val.timestamp || val.unix_itme_stamp);
		    						// console.log("data tag 1 ", val.ruleId, item.tag1.ruleId , countTemp)
		    						
	    							let countTemp =  val.analytics_results.length || 1; 
	    							item.devices["tag1"].subtotal += countTemp;  
	    						
		    					}
		    					if (val.ruleId == item.tag2.ruleId) {
		    						if (state.list[idx].devices && !state.list[idx].devices["tag2"]) {
		    							state.list[idx].devices["tag2"]={subtotal: 0, date: new Date(), name : item.tag2?.name};
		    						}
		    						// item.tag2.counts += countTemp;	    						
		    						// state.list[idx]+=countTemp
		    						item.devices["tag2"].date = Helper.formatDate(val.timestamp || val.unix_itme_stamp);
		    						// console.log("data tag 2 ", val.ruleId, item.tag2.ruleId ,countTemp)
		    							    							
		    						let countTemp = val.analytics_results.length || 1;  
		    						item.devices["tag2"].subtotal += countTemp;  
	    						
		    					}
		    					if (item.devices["tag1"].subtotal &&  item.devices["tag1"].subtotal >=0 && item.devices["tag2"].subtotal && item.devices["tag2"].subtotal>=0) {
		    						state.conte++;
		    						item.counts=Helper.renderOperation(item.operator,item.devices["tag1"].subtotal, item.devices["tag2"].subtotal );//{ t1 :item.tag1.counts , t2: item.tag2.counts}
		    					}
		    					// state.conte+=countTemp
		    				}

		    			}
		    			// state.list[idx] = {...item[it]};
		    		// }
			    })
	    	}
	    },
	    /*
	    	motion 					: ['motion_event'],					
				alarms 					: ['events_alerts'],					
				lpr 						: ['events_lpr'], 
				actions 				: ['events_action'],
				/alerts 					: ['events'],
				objects 				: ['events_object'],
				/weapon_detector : ['events'],
				/technical  			: ['events_technical'],
				smart_event 		: ['events_smart_event','events_alerts'],				
				/peripherals  		: ['events_peripheral'],
				/incidents 			: ['events_incidents'],
				/parking 				: ['events_parking'],
				avc 						: ['events_avc'],
				/data 						: ['events_data_counter'],
		*/

	},
}